import { useOutletContext } from "react-router-dom";
import useFee from "feature-module/finance/hooks/useFee";
import useFeePayment from "feature-module/finance/hooks/useFeePayment";
import { useEffect, useState } from "react";
import AddEditFeeModal from "feature-module/finance/modals/AddEditFeeModal";
import AddFeePaymentModal from "feature-module/finance/modals/AddFeePaymentModal";
import FeesContent from "./FeesContent";
import useStudent from "../hooks/useStudent";
import Loader from "components/Common/loader";
import { showConfirmDialog } from "utils/confirmDialogUtils";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";

type Ctx = { student: any | null };

const StudentFeesTab = () => {
  const { student } = useOutletContext<Ctx>();
  const [isModalAddPaymentOpen, setIsModalAddPaymentOpen] = useState(false);

  const {
    setSelectedFee,
    setIsModalOpen,
    selectedFee,
    handleCreate,
    isModalOpen,
    fetchFeeTypes,
    feeTypes,
    handleDelete: handleDeleteFee
  } = useFee();
  const { fetchFeesByStudentId, fees, loading } = useStudent();
  const { t } = useTranslation();

  const {
    handleCreate: handleCreateFeePayment,
    paymentMethods,
    fetchPaymentMethods,
    handleDelete: handleDeleteFeePayment,
  } = useFeePayment();

  useEffect(() => {
    if (!student || !student?.id) return;
    fetchFeesByStudentId({ studentId: student.id, include: "feeType,feePayments" });

    fetchFeeTypes();
    fetchPaymentMethods();
    console.log("student.id", student.id);
  }, [student]);

  const handlePaymentClick = (fee: any) => {
    setSelectedFee(fee);
    setIsModalAddPaymentOpen(true);
  };

  const refreshStudent = async () => {
    fetchFeesByStudentId({ studentId: student.id, include: "feeType,feePayments" });
  };

  const handleSaveFee = async (feeData: any) => {
    if (!selectedFee) {
      await handleCreate(feeData);
    }
    await refreshStudent();
    setIsModalOpen(false);
  };

  const handleSaveFeePayment = async (feePaymentData: any) => {
    const res = await handleCreateFeePayment(feePaymentData);
    if (res) {
      await refreshStudent();
      setIsModalAddPaymentOpen(false);
    }

  };

  const handleDeletePayment = async (paymentId: string) => {
    await handleDeleteFeePayment(paymentId);
    await refreshStudent();
  };


  const showDeleteFeeConfirm = (id: string) => {
    showConfirmDialog({
      title: t("are_you_sure_you_want_to_delete_this_fee"),
      icon: <ExclamationCircleOutlined />,
      content: t("this_action_cannot_be_undone"),
      okText: t("delete"),
      okType: "danger",
      cancelText: t("cancel"),
      onOk: async () => {
        if (handleDeleteFee) {
          const res = await handleDeleteFee(id);
          if (res) {
            await refreshStudent();
          }
        }
      },
    });
  };
  if (loading) return <Loader />;

  return (
    <>
      <FeesContent
        fees={fees}
        setSelectedFee={setSelectedFee}
        setIsModalOpen={setIsModalOpen}
        handlePaymentClick={handlePaymentClick}
        handleDeletePayment={handleDeletePayment}
        showDeleteFeeConfirm={showDeleteFeeConfirm}
      />

      <AddFeePaymentModal
        isOpen={isModalAddPaymentOpen}
        onClose={() => setIsModalAddPaymentOpen(false)}
        onSave={handleSaveFeePayment}
        feeId={selectedFee?.id || ""}
        amountNotPaid={selectedFee?.amountNotPaid || 0}
        paymentMethods={paymentMethods}
      />

      <AddEditFeeModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        onSave={handleSaveFee}
        students={[]}
        feeTypes={feeTypes}
        selectedStudent={student?.id}
      />
    </>
  );
};

export default StudentFeesTab;
